<template>
    <v-row justify="center">
        <v-dialog
            v-model="dialog"
            :persistent='true'
            width="25%"
            height="100%"
            class="modalDialog"
            no-click-animation
            >
            <v-card class="pa-3">
                <CardTitle :title="page_title" />
                    <v-container>
                        <v-row class="pa-2">
                            <p>{{ displayGolfCourseName }}</p>
                        </v-row>
                        <v-row class="pa-2">
                            <p>{{ propsPlanName }}</p>
                        </v-row>
                    </v-container>
                    <v-select
                        class="pa-2"
                        :items="benefitSelect"
                        item-value="benefit_cd"
                        item-text="benefit_name"
                        v-model="benefitValue"
                        label="特典を選択"
                        hide-details
                        width="100px"
                        />
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="green darken-4" text @click="CloseModal">閉じる</v-btn>
                    <v-btn color="green darken-4" text @click="displayAddOverLay">登録</v-btn>
                </v-card-actions>
                <AddOverLay
                    page-name="特典"
                    @processing="registPlanBenefit"
                    @cancel="closeAddOverLay"
                    :process-result="process"
                    :OverlaySwitch="addOverlay"
                />
            </v-card>
        </v-dialog>
    </v-row>
</template>

<script>
import CardTitle from '@/components/module/CardTitle';
import { authorityMixin } from '@/views/authorityMixin';
import {
    GET_PLAN_BENEFIT,
    REGIST_PLAN_BENEFIT } from '@/constants/plan';
import AddOverLay from '@/components/overlay/AddOverlay';

export default {
    components: {
        CardTitle,
        AddOverLay
    },
    mixins: [authorityMixin],
    props: [
        'dialog',
        'displayGolfCourse',
        'displayGolfCourseName',
        'propsPlanId',
        'propsPlanName'
    ],
    data () {
        return {
            // 追加確認用ポップアップ表示に関する制御値
            addOverlay: false,
            process: {
                // 処理結果
                result: '',
                // 処理結果メッセージ
                resultText: '',
                // 処理中かどうか
                processing: false
            },
            // モーダルタイトル コンポーネントに渡す値：モーダルタイトル
            page_title: '特典登録',
            // 以下入力値
            // 選択値
            benefitSelect: [],
            // 入力値
            benefitValue: '',
            // ボタンの活性・非活性
            btn: [
                { element_id: '001', element_name: '追加', isActive: true },
                { element_id: '002', element_name: '変更', isActive: true },
                { element_id: '003', element_name: '削除', isActive: true }
            ],
            vue_id: ''
        };
    },
    watch: {
        displayGolfCourse () {
            if (this.displayGolfCourse !== '') {
                this.getBenefit();
            }
        }
    },
    methods: {
        /** ----------------------------------------------
         * プランに紐づく特典の詳細を取得
         * ---------------------------------------------- */
        getBenefit () {
            this.$apollo.mutate({
                mutation: GET_PLAN_BENEFIT,
                variables: {
                    golf_group_code: process.env.VUE_APP_GROUP_CODE,
                    golf_code: this.displayGolfCourse
                }
            }).then(res => {
                const data = res.data.getBenefit.PlanBenefitList;
                this.benefitSelect = data;
            });
        },
        /** ----------------------------------------------
         * 特典の登録処理
         * ---------------------------------------------- */
        registPlanBenefit () {
            this.$apollo.mutate({
                mutation: REGIST_PLAN_BENEFIT,
                variables: {
                    plan_id: this.propsPlanId,
                    benefit_cd: this.benefitValue
                }
            }).then(res => {
                const data = res.data.registPlanBenefit.result;
                if (data === 1) {
                    this.closeAddOverLay();
                    this.CloseModal();
                } else if (data === 0) {
                    const resultText = '同じ特典が登録されています。';
                    throw new Error(resultText);
                }
            }).catch(error => {
                error = error.message.split(/:/g);
                this.$set(this.process, 'result', 0);
                this.$set(this.process, 'resultText', error[0]);
            });
        },
        /** ----------------------------------------------
         * モーダル画面を表示する処理
         * ---------------------------------------------- */
        displayAddOverLay () {
            this.addOverlay = true;
        },
        /** ----------------------------------------------
         * モーダル画面を閉じる処理
         * ---------------------------------------------- */
        closeAddOverLay () {
            this.addOverlay = false;
            this.$set(this.process, 'result', '');
            this.$set(this.process, 'resultText', '');
        },
        /** ----------------------------------------------
         * モーダル画面を閉じる際の処理
         * ---------------------------------------------- */
        CloseModal () {
            this.benefitValue = '';
            this.$emit('close');
        }
    }
};
</script>
